import { useQueryClient } from '@tanstack/react-query'
import {
  getModel,
  getProjectFiles,
  getStiffeningIntervals,
  getStiffeningProposal,
  getTensileTransmissionGraph,
  getVerticalTransmissionGraph,
} from '@queries'
import { documentationRootGuid } from 'src/constants/files'

const useModelInvalidation = () => {
  const queryClient = useQueryClient()

  return async (projectId: string) => {
    await Promise.all([
      queryClient.invalidateQueries(getModel.getKey(projectId)),
      queryClient.invalidateQueries(getVerticalTransmissionGraph.getKey(projectId)),
      queryClient.invalidateQueries(getStiffeningProposal.getKey(projectId)),
      queryClient.invalidateQueries(getStiffeningIntervals.getKey(projectId)),
      queryClient.invalidateQueries(getTensileTransmissionGraph.getKey(projectId)),
      queryClient.invalidateQueries(getProjectFiles.getKey(projectId, documentationRootGuid)),
    ])
  }
}

export default useModelInvalidation
